const TEMPLATE_NAME = 'VISIT_DASHBOARD_COUNTER';

const initialState = () => ({
  loading: false,
  loadedData: {}
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const loadedData = action.payload;
      return {
        ...state,
        loading: false,
        loadedData
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
